﻿import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Field, reduxForm} from 'redux-form'
import { renderTextField } from '../../components/core/editors';
import {connect} from 'react-redux';

import {Paper, RaisedButton, AppBar, LinearProgress} from 'material-ui';
import service from '../../services/auth-services';

const style = {
    width: '100%',
    maxWidth: '270px',
    margin: 20,
    textAlign: 'center',
    display: 'inline-block',
    position: 'relative',
    paddingBottom: "10px"
};

const errorStyle = {
    color: "red"
};

const loaderStyle = {
    position: 'absolute',
    bottom: 0
};

class Login extends Component {
    constructor(props, context) {
        super(props, context);
        this.submitForm = this.submitForm.bind(this);
    }

    submitForm(data) {
        this.props.onSubmit(data.UserName, data.Password);
    }

    render() {
        const {handleSubmit, pristine, submitting, inProgress, errors} = this.props;

        return (
            <div>
                <Paper style={style} zDepth={1}>
                    <AppBar title="Enter Credentials" showMenuIconButton={false}></AppBar>
                    <form onSubmit={handleSubmit(this.submitForm)} noValidate={true}>

                        { errors ? <p style={errorStyle}>{errors}</p> : null}

                        <div>
                            <Field name="UserName" component={renderTextField} label="User Name" required
                                   autoComplete="off"/>
                        </div>
                        <div>
                            <Field name="Password" component={renderTextField} label="Password" type="password"
                                   required/>
                        </div>

                        <br />
                        <RaisedButton label="Login" primary={true} type="submit" disabled={pristine || submitting}/>

                        { inProgress ? <LinearProgress mode="indeterminate" style={loaderStyle}/> : null }

                    </form>
                </Paper>
            </div>
        );
    }
}

const validate = values => {
    const errors = {};
    const requiredFields = ['UserName', 'Password'];
    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = 'Required';
        }
    });
    return errors;
};

const mapStateToProps = state => ({...state.auth});

const mapDispatchToProps = dispatch => ({
    onSubmit: (username, password) =>
        dispatch({type: 'LOGIN', payload: service.Auth.login(username, password)}),
    onUnload: () =>
        dispatch({type: 'LOGIN_PAGE_UNLOADED'})
});

Login.contextTypes = {
    router: PropTypes.any.isRequired
};

Login = reduxForm({
    form: 'loginForm',
    validate
})(Login);


Login = connect(mapStateToProps, mapDispatchToProps)(Login);

export default Login;